import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

const GuestGuard = ({ children, path }: any) => {
  const account = useSelector((state: any) => state.account);

  if (account.user) {
    const analyst = account.user.permissions.includes('analyst_user');

    if (['rebuyer_administrator', 'rebuyer'].includes(account.user.profile)) return <Redirect to="/transactions2" />;
    if (account.user.role === 'not_role' && analyst) return <Redirect to="/search" />;
    if (account.user.role === 'not_role') return <Redirect to="/unauthorized" />;
    window.location.assign('/');
  }

  return children;
};

export default GuestGuard;
